import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';

interface RoleGuardProps {
    children: React.ReactNode;
    allowedRoles: string[];
}

export const RoleGuard: React.FC<RoleGuardProps> = ({ children, allowedRoles }) => {
    const { user, isLoading } = useAdmin();

    if (isLoading) {
        return <div className="min-h-screen flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
        </div>;
    }

    if (!user) {
        return <Navigate to="/admin/login" replace />;
    }

    if (!allowedRoles.includes(user.role)) {
        return <Navigate to="/admin/dashboard" replace />;
    }

    return <>{children}</>;
};
